// 🚨 **The DataTables chrome relocation, in ONE place. It was the same seven statements in four packs.**
// Found by `/simplify` 2026-10-08 — three of its four agents independently, and the branch that prompted it
// had just inserted the same new line into all four `initComplete` bodies, spelled differently in each (one
// chained, three as separate lookups of the same selector, two mixing quote styles).
//
// 🔑 **Why this matters beyond tidiness: `UPGRADE_TODO.md` 10.5l.** DataTables 3 renames `#<t>_filter` and
// `#<t>_length` to `.dt-search` / `.dt-length`. With the relocation copied four times, there were ~30
// selectors to edit across four files; `grep -c "_filter\|_length\|_wrapper" app/javascript/packs/` was
// **48 references across 6 files**. `spec/features/normal/datatable_chrome_spec.rb` was written to *detect*
// that breakage — centralising here *reduces* it, so the spec and the duplication were pulling opposite ways.
//
// 📌 **The input's id is READ FROM THE VIEW, not written here, and that is the point.** It used to be the
// literal `'datatable-search-input'` in four packs *and* four `label_tag` calls — eight copies of one fact,
// where a view's `for=` was a promise the JS had to keep by hand. `CLAUDE.md` → *Role Guards* forbids exactly
// that shape ("never write a condition that has to be kept in step with another one by hand"). Now
// `shared/_datatable_search.html.erb` is the single source: it renders the label, and this reads the label's
// `for` and assigns it to the relocated input, so the two cannot disagree.
export default (tableId) => {
  const searchId = $('#search-div > label').attr('for')

  $('#datatable-actions').prependTo(`#${tableId}_wrapper`)
  $(`#${tableId}_length`).prependTo('#datatable-actions').addClass('me-3')
  // Kept in a local: the same node was then re-found as `.datatable-search` and again as `#search-div
  // input`, which is the duplication this module exists to remove — and `UPGRADE_TODO.md` 10.5l is a rename
  // of `#<t>_filter`, so this is the file that gets edited for it (`/simplify`).
  const input = $(`#${tableId}_filter input`)
    .removeClass('form-control-sm')
    .addClass('datatable-search')
    .attr({ type: 'text', id: searchId })
    .detach()
    .prependTo('#search-div')
  $(`#${tableId}_wrapper .row:first`).remove()
  $('#datatable-actions').removeClass('d-none')

  // Delegated on a persistent container is unnecessary here: `initComplete` runs after the table exists and
  // the input has just been moved into `#search-div`, which is in the server-rendered page.
  // 📌 `$clear` hoisted and `this.value` rather than a re-query: the button is server-rendered by
  // `shared/_datatable_search` and lives as long as the page, so there is nothing to re-find per keystroke.
  const $clear = $('.clear-button')
  input.on('input', function() { $clear.toggleClass('d-none', !this.value) })

  // 🔑 **TODO.md F-168. The sideways scroll that replaced DataTables Responsive** — owner decision
  // 2026-10-26, after the tables were hiding 3 of 13 columns behind an expand arrow at 1366 and 1440.
  // 📌 **Only the `<table>` is wrapped, deliberately.** The toolbar and the pagination are siblings of it
  // inside `#<id>_wrapper`, and they must NOT scroll sideways with the data — which is also the reason
  // this is not `scrollX: true`: DataTables' own scroller takes over the whole wrapper and splits the
  // header and body into two tables that have to be kept width-synced. One `overflow-x: auto` div does
  // the job with no machinery to go wrong.
  // ⚠️ After `initComplete`, so the relocations above have already moved the toolbar OUT of the way; a
  // wrap done earlier would enclose it. And `wrap` is safe per navigation: Turbolinks replaces `<body>`,
  // so the table is a fresh element with no wrapper on it.
  $(`#${tableId}`).wrap('<div class="datatable-scroll"></div>')
}
